import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=a489d6e4&scoped=true&lang=pug&"
import script from "./Popular.vue?vue&type=script&lang=js&"
export * from "./Popular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a489d6e4",
  null
  
)

export default component.exports